enum PhotoState {
  Active = 'Active',
  Deleted = 'Deleted',
  Errored = 'Errored',
  Hidden = 'Hidden',
  Preparing = 'Preparing'
}
export default PhotoState
